const isModalOpen = state => state.isModalOpen
const imgUrl = state => state.imgUrl

export default {
  isModalOpen,
  imgUrl
}
